export const STORE_OFFERS = 'casino-heroes/depositOffers/STORE_OFFERS'
